import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bgCurrent", "bgNext", "fgCurrent", "fgNext"]
  static values = { images: Array, bgImages: Array }

  connect() {
    if (this.imagesValue.length <= 1) return

    this.currentIndex = 0
    this._preload(1)
    this.timer = setInterval(() => this.slide(), 5000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  slide() {
    const nextIndex = (this.currentIndex + 1) % this.imagesValue.length
    const nextFg = this.imagesValue[nextIndex]
    const nextBg = this.bgImagesValue[nextIndex] || nextFg

    const pairs = [
      [this.bgCurrentTarget, this.bgNextTarget, nextBg],
      [this.fgCurrentTarget, this.fgNextTarget, nextFg]
    ]

    pairs.forEach(([, nxt, src]) => {
      nxt.src = src
      nxt.style.transition = "none"
      nxt.style.transform = "translateX(100%)"
    })

    this.bgNextTarget.offsetWidth // force reflow

    const ease = "transform 1s cubic-bezier(0.4, 0, 0.2, 1)"
    pairs.forEach(([cur, nxt]) => {
      cur.style.transition = ease
      nxt.style.transition = ease
      cur.style.transform = "translateX(-100%)"
      nxt.style.transform = "translateX(0)"
    })

    setTimeout(() => {
      pairs.forEach(([cur, nxt, src]) => {
        cur.style.transition = "none"
        cur.src = src
        cur.style.transform = "translateX(0)"
        nxt.style.transition = "none"
        nxt.style.transform = "translateX(100%)"
      })
      this.currentIndex = nextIndex
      this._preload((nextIndex + 1) % this.imagesValue.length)
    }, 1050)
  }

  _preload(index) {
    const fg = this.imagesValue[index]
    const bg = this.bgImagesValue[index]
    if (fg) new Image().src = fg
    if (bg && bg !== fg) new Image().src = bg
  }
}

